/**
 * @module experience/shop/cart/cart-reivew
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { SetFocusService } from '@support/shared/widgets/services/set-focus.service';

@Directive({
  selector: '[tmoSetFocus]',
})
export class SetFocusDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private setFocusService: SetFocusService
  ) {}

  public ngOnInit(): void {
    this.setFocusService.focusUpdated$.subscribe((event: boolean) => {
      if (event) {
        this.renderer.selectRootElement(this.el.nativeElement).focus();
      }
    });
  }
}
